"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgDimensionsDiagramOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M30 7V5h-8v2h3v18h-3v2h8v-2h-3v-3h2v-2h-2v-3h2v-2h-2v-3h2v-2h-2V7h3zM2.05 10.29v11.47L12 27.5l9.94-5.74V10.29L12 4.55zm17.87 10.32L12 25.19l-7.95-4.58v-9.17L12 6.86l7.94 4.58z" }),
        React.createElement("path", { d: "M7.78 14.9a4.29 4.29 0 00.44 3.3A4.36 4.36 0 0012 20.38a4.29 4.29 0 002.17-.59 4.35 4.35 0 00-4.35-7.54 4.3 4.3 0 00-2.04 2.65zm3-.91a2.27 2.27 0 011.22-.32 2.35 2.35 0 11-2.27 1.74A2.3 2.3 0 0110.81 14z" })));
}
exports.default = SvgDimensionsDiagramOutline;
//# sourceMappingURL=DimensionsDiagramOutline.js.map